import React from 'react'
import { ModelProxy } from '@morningtrain/react-resources'
import { Table as TableUI } from 'ui/table'
import { WhenInTableBody, WhenInTableFooter, WhenInTableHead } from '@morningtrain/react-columns'

export default function Table ({
  children,
  row,
  selectMultiple = false,
  operationContext = {},
  footer = null,
  extraHeader = null,
  withFooter = false,
  striped = false,
  className = '',
  ...forwardProps
}) {
  return (
    <TableUI striped={striped} tableProps={{ selectOnClick: true, selectMultiple: selectMultiple, row: row, extraHeader, withFooter, footer, className, ...forwardProps }}>
      <WhenInTableHead>
        {children}
      </WhenInTableHead>
      <WhenInTableBody>
        <ModelProxy operationContext={operationContext}>
          {children}
        </ModelProxy>
      </WhenInTableBody>
      <WhenInTableFooter>
        {children}
      </WhenInTableFooter>
    </TableUI>
  )
}
